import { DestroyRef, Injectable } from '@angular/core';

/**
 * BE-1239: реестр открытых оверлеев в порядке открытия. Нужен, чтобы Esc и ловушка
 * фокуса работали только у верхнего.
 *
 * BE-1293: сюда встаёт не только модальное окно, но и выезжающая панель `app-sheet` —
 * на экране «Документы» шторка фильтров и окно подписания Заявки бывают открыты
 * одновременно. Реестр к виду оверлея безразличен и отвечает только «кто сверху».
 *
 * Порядок открытия, а не вложенность в разметке: в проекте три разные топологии, и
 * «верхнее» ни в одной из них не определяется по DOM. Глобальное подтверждение объявлено
 * в app.html вне окна, поверх которого рисуется; локальное подтверждение — сосед окна в
 * том же шаблоне; а карточка магазина, наоборот, физически содержит окно правки и окно
 * обрезки картинки. Общее у всех трёх ровно одно: окно, открытое последним, и есть то,
 * которое пользователь видит сверху.
 *
 * Это не ConfirmationLockService: тот отбивает второе подтверждение поверх первого и знает
 * только про подтверждения. И не OverlayCoordinatorService: тот закрывает предыдущий
 * поповер при открытии нового. Здесь никто никого не закрывает и не отбивает — реестр
 * только отвечает на вопрос, кто сверху.
 */
@Injectable({ providedIn: 'root' })
export class ModalStackService {
  private readonly stack: object[] = [];

  /** Пуст ли реестр. Нужен спекам: незакрытая запись утекает в следующий тест. */
  isEmpty(): boolean {
    return this.stack.length === 0;
  }

  /**
   * Ставит окно на вершину стека и возвращает признак «я сейчас верхнее». Снятие со стека
   * происходит само при уничтожении окна — тот же контракт, что у
   * `ConfirmationLockService.acquire`.
   */
  push(destroyRef: DestroyRef): () => boolean {
    const token = {};
    this.stack.push(token);

    destroyRef.onDestroy(() => {
      // Вырезаем по месту, а не обрезаем хвост: окна закрываются и не в том порядке, в
      // котором открывались — нижнее может уйти вместе со сменой маршрута под оверлеем.
      const index = this.stack.indexOf(token);
      if (index !== -1) {
        this.stack.splice(index, 1);
      }
    });

    return () => this.stack[this.stack.length - 1] === token;
  }
}
